import type { IFetcher } from "../util/io/Fetcher";
import type { UploadCompleteRequestModel, UploadCompleteResultModel } from "../../OpenApi/api";

export interface IPatientUploadCompleteCallbackStore {
    completeUpload(files: string[], sourceId: number, uploadCode: string | null, emailAddress: string | null, mobilePhone: string | null, comment: string | null): Promise<UploadCompleteResultModel>;
}

export class PatientUploadCompleteCallbackStore implements IPatientUploadCompleteCallbackStore {
    private static readonly Url: string = "/POW4/Upload/Complete";

    constructor(private readonly _fetcher: IFetcher) {}

    public async completeUpload(
        files: string[],
        sourceId: number,
        uploadCode: string | null,
        emailAddress: string | null,
        mobilePhone: string | null,
        comment: string | null
    ): Promise<UploadCompleteResultModel> {
        const { _fetcher } = this;
        
        const request: UploadCompleteRequestModel = {
            files: files,
            sourceId: sourceId,
            dicomUploadCode: uploadCode,
            emailAddress: emailAddress,
            mobilePhone: mobilePhone,
            comment: comment
        };

        return await _fetcher.postJSON<UploadCompleteResultModel>(PatientUploadCompleteCallbackStore.Url, request);
    }
}
